import { ErrorCode } from '@app/shared/errors/error.models';
import { Language } from '@app/shared/models/language';
import { Object } from '@app/shared/models/shared.models';

export const errorMessagesFactory = ({ angularLocale, cultureName }: Language): {
	[key in ErrorCode]?: {
		message: (metadata: Object) => string
	}
} => {

	/**
	 * If we need the datepipe for formatting dates, we can use it here.
	 * const datePipe = new DatePipe(angularLocale);
	 */

	return {
		[ErrorCode.ActivityExtensionRequestInvalidTenantAdmin]: {
			message: () => $localize`:@@error.activity-extension-request-invalid-tenant-admin:There are no administrators or managers who can approve the extension requested for your activity. Assign your own line manager or add tenant administrators!`
		},
		[ErrorCode.AssessmentsCorporateAccess]: {
			message: metadata => $localize`:@@error.assessments-corporate-access:The following assessments have corporate report access disabled: ${ metadata['assessmentNames']?.join(', ') }.`
		},
		[ErrorCode.AssessmentsIndividualAccess]: {
			message: metadata => $localize`:@@error.assessments-individual-access:The following assessments have individual report access disabled: ${ metadata['assessmentNames']?.join(', ') }.`
		},
		[ErrorCode.AssessmentsIndividualReportNoResults]: {
			message: metadata => $localize`:@@error.assessments-individual-report-no-results:The following assessments have no results for the selected user: ${ metadata['assessmentNames']?.join(', ') }.`
		},
		[ErrorCode.AssessmentsResetAccess]: {
			message: () => $localize`:@@error.assessments-reset-access:You do not have the required permissions to reset the assessment.`
		}
	};
};
